<div id="app-scroll-fallback"></div>
<div class="app-layout">
	<app-header [userInfo]="userInfo$ | async" (toggleSidenav)="toggleSidenav()"></app-header>

	<mat-sidenav-container class="app-sidenav__container" autosize>

		<mat-sidenav *ngIf="mobile$ | async" role="navigation" mode="over"
								 class="app-sidenav--mobile"
								 [opened]="isExpanded$ | async">
			<app-sidenav-mobile [userInfo]="userInfo$ | async" (toggleSidenav)="toggleSidenav()"></app-sidenav-mobile>
		</mat-sidenav>

		<mat-sidenav *ngIf="(mobile$ | async) === false" role="navigation" mode="side" [opened]="true">
			<app-sidenav-desktop [isExpanded$]="isExpanded$" (toggleSidenav)="toggleSidenav()"></app-sidenav-desktop>
		</mat-sidenav>

		<mat-sidenav-content class="u-base-colors" id="app-content">
			<a class="app-sidenav__toggle d-none d-lg-block" (click)="toggleSidenav()">
				<mat-icon *ngIf="isExpanded$ | async" class="app-sidenav__toggle-icon" fontSet="voest-icons__arrow-left"
									fontIcon="arrow-left"></mat-icon>
				<mat-icon *ngIf="(isExpanded$ | async) === false" class="app-sidenav__toggle-icon"
									fontSet="voest-icons__arrow-right"
									fontIcon="arrow-right"></mat-icon>
			</a>

			<div class="app-content">
				<router-outlet></router-outlet>
			</div>

			<app-footer class="app-footer"></app-footer>
		</mat-sidenav-content>

	</mat-sidenav-container>
</div>
